import { Component, ChangeDetectionStrategy, OnInit, Input, Output, EventEmitter, ElementRef, ViewChild } from "@angular/core";
import { UserService } from "../_services/user.service";
import { FuseWidgetComponent } from "./widget/widget.component";
import { Router } from "@angular/router";
import { AngularFireDatabase } from "angularfire2/database-deprecated";


@Component({
  // tslint:disable-next-line:component-selector
  selector: 'app-post-item3',
  templateUrl: './post-item3.component.html',
  styleUrls: ['./post-item3.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PostItemComponent3 implements OnInit {
  user: any;
  @Output() reload = new EventEmitter();
  @Input() whichPage: any;
  @Output() flipped = new EventEmitter();
  @ViewChild(FuseWidgetComponent) widget: ElementRef;
  firstPost: any;
  constructor(private userService: UserService, private el: ElementRef,public router: Router,private afm:AngularFireDatabase) {
    
    this.userService.getUser().subscribe(user => {
      this.user = user
    })
    
  }

  ngOnInit(): void {
   
  }
  flip(event) {
    this.flipped.emit(event);
    this.el.nativeElement.scrollIntoView({ behavior: "smooth", block: "center" });
  }
  goBack(){
    return window.history.back();
  }
}





// WEBPACK FOOTER //
// C:/Users/Lenovo/Desktop/bigadvicefirestore/src/app/post-item/post-item3.component.ts